
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("45RgY", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");


var $1oCLl = parcelRequire("1oCLl");


var $4JDbp = parcelRequire("4JDbp");


var $4cOi8 = parcelRequire("4cOi8");
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");


var $g3LxX = parcelRequire("g3LxX");

const $d383b1063b3ff59a$var$ItemSelectedToEditWrapperStyles = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelectedToEdit: isSelectedToEdit, isSelectedToRemove: isSelectedToRemove, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isSelectedToEdit && "_1ivtdfik",
            __cmplp.isSelectedToRemove && "_1ivt19ep",
            __cmplp.isSelectedToRemove && "_8ibab3bt _zbo0stnw _xu41idpf _1dqsidpf _pbjsidpf _139fidpf _1pm8kb7n _1b0d105o _1l6t1gly",
            __cmplp.className
        ])
    });
});
const $d383b1063b3ff59a$export$d3fc0aff4df25c77 = ({ extensionLocalId: extensionLocalId, itemId: itemId, children: children })=>{
    const itemRef = (0, $42omo.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId }] = (0, $g3LxX.useExtensionsState)();
    const onItemClick = (0, $42omo.useCallback)(()=>{
        if (extensionLocalId === selectedExtensionLocalId) {
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(itemId);
        }
    }, [
        itemId,
        extensionLocalId,
        selectedExtensionLocalId,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const isSelectedToEdit = selectedToEditCardId === itemId && extensionLocalId === selectedExtensionLocalId;
    const isSelectedToRemove = selectedToRemoveCardId === itemId && extensionLocalId === selectedExtensionLocalId;
    return /*#__PURE__*/ (0, $l998X.jsx)($d383b1063b3ff59a$var$ItemSelectedToEditWrapperStyles, {
        ref: itemRef,
        isSelectedToEdit: isSelectedToEdit,
        isSelectedToRemove: isSelectedToRemove,
        onClick: onItemClick,
        children: children
    });
};




var $fOKpq = parcelRequire("fOKpq");


var $1A6sR = parcelRequire("1A6sR");


var $5Ac5G = parcelRequire("5Ac5G");


var $9Uxg8 = parcelRequire("9Uxg8");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $8C5kA = parcelRequire("8C5kA");


var $frt7o = parcelRequire("frt7o");










/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $8Yfbq = parcelRequire("8Yfbq");


var $gtD4K = parcelRequire("gtD4K");


var $1qfLF = parcelRequire("1qfLF");





var $bPdpL = parcelRequire("bPdpL");


var $5tOl1 = parcelRequire("5tOl1");


var $7YEWU = parcelRequire("7YEWU");


var $lOHzS = parcelRequire("lOHzS");




var $u9agA = parcelRequire("u9agA");


var $jZuqn = parcelRequire("jZuqn");





var $ahPKE = parcelRequire("ahPKE");

var $IBZYB = parcelRequire("IBZYB");

var $lPcXt = parcelRequire("lPcXt");








var $cgtv4 = parcelRequire("cgtv4");

const $757235e74411961a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    previous: {
        id: "company-hub.carousel-extension.carousel-navigation.row-orientation.previous",
        defaultMessage: "Previous"
    },
    next: {
        id: "company-hub.carousel-extension.carousel-navigation.row-orientation.next",
        defaultMessage: "Next"
    },
    play: {
        id: "company-hub.carousel-extension.carousel-navigation.play",
        defaultMessage: "Play"
    },
    pause: {
        id: "company-hub.carousel-extension.carousel-navigation.pause",
        defaultMessage: "Pause"
    }
});


const $c9e066ab3f44548b$var$NAVIGATION_PADDING_BREAKPOINT_WIDTH = 800;
const $c9e066ab3f44548b$var$styles = {
    navigationContainer: "_1bsb1osq _p12f1osq",
    navigationContainerWithPadding: "_18zrpxbi",
    thumbnailNavigationContainer: "_1reo15vq _18m915vq _16jlkb7n _1o9zidpf _i0dlf1ug _1e0c1txw _kqswh2mm _19bvze3t",
    left: "_1bah1y6m",
    center: "_1bah1h6o",
    right: "_1bahesu3",
    progressContainer: "_16jlkb7n _1o9zidpf _i0dlf1ug",
    progressPadding: "_19bv1ejb",
    iconBackgroundColor: "_2rko1rr0 _bfhkvuon"
};
const $c9e066ab3f44548b$export$bb2ef5dc2942d541 = ({ extensionLocalId: extensionLocalId, frames: frames, frameIds: frameIds, selectedHeroFrameIndex: selectedHeroFrameIndex, isHovered: isHovered, isCarouselVisible: isCarouselVisible, isAutoplayEnabled: isAutoplayEnabled, navigationStyle: navigationStyle, renderFrame: renderFrame, handleNavigationFrameUpdate: handleNavigationFrameUpdate, width: width = 0 })=>{
    const isThumbnailNavigation = navigationStyle === (0, $9Uxg8.NavigationStyle).THUMBNAILS;
    const [isAutoPlaying, setIsAutoPlaying] = (0, $42omo.useState)(isAutoplayEnabled);
    const intervalRef = (0, $42omo.useRef)(null);
    const frameSize = (0, $9Uxg8.framesDimensions)[(0, $9Uxg8.FrameSizes).NAVIGATION_THUMBNAIL_V2];
    const { calculations: calculations, setCurrentCardsGridWidth: setCurrentCardsGridWidth, setCurrentCardWidth: setCurrentCardWidth } = (0, $lPcXt.useWidthAndSpacingCalculations)({
        numberOfCards: frames.length,
        cardDimensions: (0, $9Uxg8.framesDimensions)[(0, $9Uxg8.FrameSizes).NAVIGATION_THUMBNAIL_V2]
    });
    const { cardWidthOnFullRow: cardWidthOnFullRow, isFirstRowFull: isFirstRowFull, gaps: gaps, maxNumberOfCardsPerRow: maxNumberOfCardsPerRow, isFirstRowOverflown: isFirstRowOverflown } = calculations;
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(setCurrentCardsGridWidth, 200);
    const spaceBetweenFrames = gaps.spaceBetweenCards;
    const { scrollToPrevious: scrollToPrevious, scrollToNext: scrollToNext, scrollToIndex: scrollToIndex, requestScrollIndex: requestScrollIndex, resetScrollIndex: resetScrollIndex } = (0, $IBZYB.useOrientationScrolling)({
        maxNumberOfItemsPerRow: maxNumberOfCardsPerRow,
        numberOfItems: frames?.length,
        isRow: true
    });
    const handleNextClick = (0, $42omo.useCallback)(()=>{
        if (selectedHeroFrameIndex < frames.length - 1) {
            handleNavigationFrameUpdate(selectedHeroFrameIndex + 1);
            scrollToNext();
        } else {
            requestScrollIndex(0);
            handleNavigationFrameUpdate(0);
        }
    }, [
        selectedHeroFrameIndex,
        frames.length,
        handleNavigationFrameUpdate,
        scrollToNext,
        requestScrollIndex
    ]);
    const handlePreviousClick = (0, $42omo.useCallback)(()=>{
        if (selectedHeroFrameIndex > 0) {
            scrollToPrevious();
            handleNavigationFrameUpdate(selectedHeroFrameIndex - 1);
        } else {
            const lastFrameIndex = frames.length - 1;
            requestScrollIndex(lastFrameIndex);
            handleNavigationFrameUpdate(lastFrameIndex);
        }
    }, [
        selectedHeroFrameIndex,
        frames.length,
        handleNavigationFrameUpdate,
        scrollToPrevious,
        requestScrollIndex
    ]);
    const handlePausePlayClick = ()=>{
        setIsAutoPlaying((prev)=>!prev);
    };
    const handleSelect = ({ index: selectedIndex })=>{
        handleNavigationFrameUpdate(selectedIndex);
    }; // This useEffect is used to Auto-scroll every X seconds
    (0, $42omo.useEffect)(()=>{
        if (isAutoPlaying && !isHovered) intervalRef.current = setInterval(()=>{
            if (isCarouselVisible()) handleNextClick();
        }, (0, $5Ac5G.AUTOPLAY_SECONDS) * 1000);
        return ()=>{
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [
        isAutoPlaying,
        isCarouselVisible,
        isHovered,
        selectedHeroFrameIndex,
        handleNextClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($c9e066ab3f44548b$var$styles.navigationContainer, width > $c9e066ab3f44548b$var$NAVIGATION_PADDING_BREAKPOINT_WIDTH && $c9e066ab3f44548b$var$styles.navigationContainerWithPadding),
        space: "space.100",
        alignBlock: "center",
        testId: "carousel-navigation",
        children: [
            isAutoplayEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                xcss: (0, $1Whri.cx)($c9e066ab3f44548b$var$styles.iconBackgroundColor),
                space: "space.050",
                alignInline: "start",
                testId: "carousel-navigation-autoplay",
                children: isAutoPlaying ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    shape: "circle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($7YEWU))),
                    label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $757235e74411961a$export$defe85febe8b728c).pause
                    }),
                    onClick: handlePausePlayClick
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    shape: "circle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($lOHzS))),
                    label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $757235e74411961a$export$defe85febe8b728c).play
                    }),
                    onClick: handlePausePlayClick
                })
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($c9e066ab3f44548b$var$styles.iconBackgroundColor),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    shape: "circle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
                    label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $757235e74411961a$export$defe85febe8b728c).previous
                    }),
                    onClick: handlePreviousClick
                })
            }),
            isThumbnailNavigation ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($c9e066ab3f44548b$var$styles.thumbnailNavigationContainer, isFirstRowOverflown ? $c9e066ab3f44548b$var$styles.left : $c9e066ab3f44548b$var$styles.center),
                style: {
                    gap: `${spaceBetweenFrames}px`
                },
                children: [
                    frames.map((frame, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ahPKE.CardOrientationWrapper), {
                            cardId: frameIds[index],
                            isFirstRowFull: isFirstRowFull,
                            cardWidthOnFullRow: cardWidthOnFullRow,
                            setWidth: index === 0 ? setCurrentCardWidth : undefined,
                            scrollToCard: index === scrollToIndex,
                            clearScrollToCard: resetScrollIndex,
                            testId: `carousel-navigation-content-frames-row-frame-${index}`,
                            index: index,
                            requestScrollIndex: requestScrollIndex,
                            extensionLocalId: extensionLocalId,
                            hasInlinePadding: true,
                            itemDimensions: frameSize,
                            children: renderFrame(frame, index)
                        }, index)),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.WidthObserver), {
                        setWidth: throttledSetWidth,
                        offscreen: true
                    })
                ]
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                alignInline: "center",
                xcss: (0, $1Whri.cx)($c9e066ab3f44548b$var$styles.progressContainer, isAutoplayEnabled && $c9e066ab3f44548b$var$styles.progressPadding),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jZuqn.default), {
                    values: frameIds,
                    selectedIndex: selectedHeroFrameIndex,
                    onSelect: handleSelect,
                    ariaControls: `${(0, $5Ac5G.ARIA_CONTROLS_PREFIX)}${extensionLocalId}`
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                alignInline: "end",
                testId: "carousel-navigation-content-cards-row-navigation",
                children: [
                    isAutoplayEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        xcss: (0, $1Whri.cx)($c9e066ab3f44548b$var$styles.iconBackgroundColor),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            shape: "circle",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
                            label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $757235e74411961a$export$defe85febe8b728c).previous
                            }),
                            onClick: handlePreviousClick
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        xcss: (0, $1Whri.cx)($c9e066ab3f44548b$var$styles.iconBackgroundColor),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            shape: "circle",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))),
                            label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $757235e74411961a$export$defe85febe8b728c).next
                            }),
                            onClick: handleNextClick
                        })
                    })
                ]
            })
        ]
    });
};





const $7e179243d9fc0e64$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    frameLabel: {
        id: "company-hub.carousel-extension.card-strip.card.label",
        defaultMessage: "slide {positionInSet} of {setSize}"
    }
});


const $a67f58337016b064$var$Frame = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastFrame: isLastFrame, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_t9utdfik _6w6fdfik _mizu1r31 _ra3xglyw _128m1o36",
            __cmplp.isLastFrame ? "_2hwxze3t" : "_2hwxutpp",
            __cmplp.className
        ])
    });
});
const $a67f58337016b064$var$FrameNew = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastFrame: isLastFrame, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb13lo",
            __cmplp.isLastFrame ? "_2hwxze3t" : "_2hwxutpp",
            __cmplp.className
        ])
    });
});
const $a67f58337016b064$export$dfca4ddd2f0987f2 = ({ isInViewMode: isInViewMode, frames: frames, frameIds: frameIds, selectedHeroFrameIndex: selectedHeroFrameIndex, isHovered: isHovered = false, extensionLocalId: extensionLocalId = 'default-extension-local-id', isAutoplayEnabled: isAutoplayEnabled = false, isCarouselVisible: isCarouselVisible, navigationStyle: navigationStyle = (0, $9Uxg8.NavigationStyle).THUMBNAILS, setSelectedHeroFrameIndex: setSelectedHeroFrameIndex, width: width })=>{
    const intl = (0, $8C5kA.default)();
    const [_state, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId }] = (0, $g3LxX.useExtensionsState)();
    const handleUpdateCardOnNavigation = (0, $42omo.useCallback)((index)=>{
        setSelectedHeroFrameIndex(index);
        if (!isInViewMode) {
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(frameIds[index]);
        }
    }, [
        setSelectedHeroFrameIndex,
        isInViewMode,
        setSelectedToEditCardId,
        setIsInAutoFocusMode,
        frameIds
    ]);
    const handleSelectFrame = (0, $42omo.useCallback)((event, index)=>{
        event?.stopPropagation();
        handleUpdateCardOnNavigation(index);
    }, [
        handleUpdateCardOnNavigation
    ]);
    const handleKeyDownAsButtonClick = (0, $42omo.useCallback)((event, index)=>{
        event.stopPropagation(); // Keyboard support for button: https://www.w3.org/TR/wai-aria-practices/examples/button/button.html
        // event.key spec: https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
        const ACTIVATE_BUTTON_KEYS = [
            'Enter',
            'Spacebar',
            ' '
        ];
        if (ACTIVATE_BUTTON_KEYS.includes(event.key)) {
            event.preventDefault();
            handleSelectFrame(undefined, index);
        }
    }, [
        handleSelectFrame
    ]);
    const renderFrame = (0, $42omo.useCallback)((card, index)=>{
        return (0, $1oCLl.expValEquals)('company_hub_carousel_thumbnails-refactor', 'isEnabled', true) ? /*#__PURE__*/ (0, $l998X.jsx)($a67f58337016b064$var$FrameNew, {
            "data-testid": "frame-strip-frame",
            tabIndex: 0,
            isLastFrame: index === frames.length - 1,
            children: card
        }, frameIds[index]) : /*#__PURE__*/ (0, $l998X.jsx)($a67f58337016b064$var$Frame, {
            "data-testid": "frame-strip-frame",
            role: "button",
            tabIndex: 0,
            "aria-current": selectedHeroFrameIndex === index,
            "aria-label": intl.formatMessage((0, $7e179243d9fc0e64$export$defe85febe8b728c).frameLabel, {
                positionInSet: index + 1,
                setSize: frames.length
            }),
            onClick: (event)=>handleSelectFrame(event, index),
            onKeyDown: (event)=>handleKeyDownAsButtonClick(event, index),
            isLastFrame: index === frames.length - 1,
            children: card
        }, frameIds[index]);
    }, [
        intl,
        frames,
        frameIds,
        selectedHeroFrameIndex,
        handleSelectFrame,
        handleKeyDownAsButtonClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c9e066ab3f44548b$export$bb2ef5dc2942d541), {
        width: width,
        frames: frames,
        frameIds: frameIds,
        extensionLocalId: extensionLocalId,
        renderFrame: renderFrame,
        handleNavigationFrameUpdate: handleUpdateCardOnNavigation,
        selectedHeroFrameIndex: selectedHeroFrameIndex,
        isHovered: isHovered,
        isCarouselVisible: isCarouselVisible,
        isAutoplayEnabled: isAutoplayEnabled,
        navigationStyle: navigationStyle
    });
};
const $a67f58337016b064$export$6239edc19b7276da = (0, $frt7o.default)($a67f58337016b064$export$dfca4ddd2f0987f2, {
    overflowSelector: '.frame-strip-overflow',
    useShadowObserver: true
});



var $jPFXE = parcelRequire("jPFXE");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $7sObp = parcelRequire("7sObp");








var $gj7hi = parcelRequire("gj7hi");





var $2W0qg = parcelRequire("2W0qg");


var $2R1C4 = parcelRequire("2R1C4");

var $5TXU5 = parcelRequire("5TXU5");

var $Y5kOr = parcelRequire("Y5kOr");

var $5znEc = parcelRequire("5znEc");


var $9CM6e = parcelRequire("9CM6e");





var $19TyP = parcelRequire("19TyP");



const $851669374477a92c$export$1861ee29fc9bca35 = 'https://www.atlassian.com/';
const $851669374477a92c$export$ea1683885a045a91 = ()=>{
    if (typeof window === 'undefined' || !window.location?.href) return $851669374477a92c$export$1861ee29fc9bca35;
    return window.location.href;
};




var $aPwHF = parcelRequire("aPwHF");


var $kHNfU = parcelRequire("kHNfU");

var $jqjsu = parcelRequire("jqjsu");




/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 










const $b79beb1b2c99f451$var$commonSmartlinkOverrideStyles = null;
const $b79beb1b2c99f451$export$1380ef7d0b342537 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, isHero: isHero, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_g6c7usvi _gwatidpf _1h8x1osq _1gpskb7n _9u4k1osq",
            __cmplp.isSelected ? "_t1vn1law" : "_t1vn1beh",
            __cmplp.isHero ? "_1dah15yp" : "_1dahtlke",
            __cmplp.className
        ])
    });
});
const $b79beb1b2c99f451$export$eb2540e3027f8342 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, maxWidth: maxWidth, hasRoundedCorners: hasRoundedCorners, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $7sObp.default)(`${__cmplp.height}px`),
            "--_zam2fy": (0, $7sObp.default)(`${__cmplp.minWidth}px`),
            "--_zncvnb": (0, $7sObp.default)(`${__cmplp.maxWidth}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_idxo15vq _1wrb15vq _150ekb7n _zoo0vrvc _14mp2nrh _10l4v3iq _1wgc684e _1m9tidpf _11soidpf _mxl91y6m _1mn51h6o _17pytlke _1hx11e53 _zaz01ugb",
            __cmplp.hasRoundedCorners ? "_4u0g1y44" : "_4u0gidpf",
            __cmplp.className
        ])
    });
});





const $65e0ee6de15b2b8b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    emptyStatePlaceholderTitle: {
        id: "company-hub.carousel-extension.carousel-content.extra-small-frame.placeholder-title",
        defaultMessage: "Add a title"
    }
});


const $41e0790936a03f2d$var$NavigationThumbnailWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, maxWidth: maxWidth, hasRoundedCorners: hasRoundedCorners, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $7sObp.default)(`${__cmplp.height}px`),
            "--_zam2fy": (0, $7sObp.default)(`${__cmplp.minWidth}px`),
            "--_zncvnb": (0, $7sObp.default)(`${__cmplp.maxWidth}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1dqonqa1 _1o9zkb7n _2lx2vrvc _4t3i2nrh _1ul9v3iq _p12f684e",
            __cmplp.hasRoundedCorners ? "_2rko1y44" : "_2rkoidpf",
            __cmplp.isSelected ? "_1h6dq98m" : "_1h6di8nm",
            __cmplp.className
        ])
    });
});
const $41e0790936a03f2d$var$styles = {
    pressable: "_ca0q1i6y _n3td1i6y _19bvxmi2 _1bsb1osq _bfhkr01l",
    container: "_4t3i1ylp",
    selectedToEdit: "_1a37dfik",
    selectedToRemove: "_1a3719ep",
    image: "_1bsbckbl _4t3i1ylp",
    textWrapper: "_19bvu2gc _ca0q1b66 _n3td1b66"
};
const $41e0790936a03f2d$var$textStyles = null;
const $41e0790936a03f2d$export$3c072ff478476aa0 = ({ cardId: cardId, link: link, title: title, imageSrc: imageSrc, isSelected: isSelected, contentId: contentId, isEmpty: isEmpty, minWidth: minWidth, maxWidth: maxWidth, wrapperHeight: wrapperHeight, hasRoundedCorners: hasRoundedCorners, layout: layout, backgroundColor: savedBackgroundColor, onFailed: onFailed, onSucceeded: onSucceeded, setSelectedHeroFrameIndex: setSelectedHeroFrameIndex, index: index, isSelectedToEdit: isSelectedToEdit, isSelectedToRemove: isSelectedToRemove })=>{
    const { isRestricted: isRestricted, isUnauthorized: isUnauthorized, trackAndCategorizeError: trackAndCategorizeError, trackSuccess: trackSuccess } = (0, $aPwHF.useTrackedSmartCardState)(cardId, link, onSucceeded, onFailed);
    const intl = (0, $8C5kA.default)();
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $fOKpq.useProductDependencies)();
    const { showUnsplashImage: showUnsplashImage, showExternalSiteImage: showExternalSiteImage, showCustomUploadedImage: showCustomUploadedImage } = (0, $jqjsu.getImageTypeToShow)({
        imageSrc: imageSrc
    });
    const { getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $19TyP.useDarkModeColors)(isSSRProductInDarkMode);
    const backgroundColor = getDarkModeCompatibleBackgroundColor(savedBackgroundColor ?? '#FFFFFF');
    const substituteBackgroundColorForImage = layout === (0, $4cOi8.CommonLayout).NO_IMAGE_BACKGROUND && backgroundColor;
    const showCustomTitleUnauthed = isUnauthorized && !!title;
    const showCustomTitleRestricted = isRestricted && !!title;
    const fallbackUrl = (0, $851669374477a92c$export$ea1683885a045a91)();
    const oldThumbnail = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $b79beb1b2c99f451$export$1380ef7d0b342537), {
            isSelected: isSelected,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b79beb1b2c99f451$export$eb2540e3027f8342), {
                minWidth: minWidth ?? (0, $9Uxg8.framesDimensions)[(0, $9Uxg8.FrameSizes).NAVIGATION_THUMBNAIL].minWidth,
                maxWidth: maxWidth ?? (0, $9Uxg8.framesDimensions)[(0, $9Uxg8.FrameSizes).NAVIGATION_THUMBNAIL].maxWidth,
                height: wrapperHeight ?? (0, $9Uxg8.framesDimensions)[(0, $9Uxg8.FrameSizes).NAVIGATION_THUMBNAIL].height,
                hasRoundedCorners: hasRoundedCorners,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $9CM6e.CardSSR), {
                    id: cardId,
                    appearance: "inline",
                    frameStyle: "show",
                    platform: "web",
                    ui: {
                        theme: (0, $5TXU5.SmartLinkTheme).Black,
                        clickableContainer: false,
                        size: (0, $5TXU5.SmartLinkSize).Large
                    },
                    url: link || fallbackUrl,
                    onResolve: trackSuccess,
                    onError: trackAndCategorizeError,
                    children: [
                        substituteBackgroundColorForImage && /*#__PURE__*/ (0, $l998X.jsx)((0, $2R1C4.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                style: {
                                    backgroundColor: backgroundColor
                                },
                                "data-testid": "backgroundColorBlock",
                                className: (0, $gMc0m.default)([
                                    $41e0790936a03f2d$var$customBackgroundStyles.backgroundColorOnly
                                ])
                            })
                        }),
                        !substituteBackgroundColorForImage && (showUnsplashImage || showExternalSiteImage) && /*#__PURE__*/ (0, $l998X.jsx)((0, $Y5kOr.default), {
                            ignoreContainerPadding: true,
                            placement: (0, $5TXU5.MediaPlacement).Left,
                            overrideUrl: imageSrc
                        }),
                        !substituteBackgroundColorForImage && showCustomUploadedImage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2R1C4.default), {
                            className: (0, $gMc0m.default)([
                                "_kqswstnw _1bsbt9kd _154ize3t _94n5ze3t _1ltvze3t",
                                "_1bsboahv"
                            ]),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHNfU.CustomImageUploadRenderer), {
                                contentId: contentId,
                                imageSrc: imageSrc
                            })
                        }) : null,
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5znEc.default), {
                            hideIcon: true,
                            text: // a link with no title should expect undefined
                            isEmpty ? title || intl.formatMessage((0, $65e0ee6de15b2b8b$export$defe85febe8b728c).emptyStatePlaceholderTitle) : title,
                            maxLines: 2,
                            anchorTarget: "_self",
                            className: (0, $gMc0m.default)([
                                "_19pkze3t _18u01b66 _1bsb1osq _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha2glyw _15zvglyw _w7swglyw _1bgkglyw _s41oglyw _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _ru7vglyw _1b7mglyw _675qglyw _fn1sglyw _d6hsglyw _zh3ri7a9 _2ax2kb7n",
                                (showCustomTitleUnauthed || showCustomTitleRestricted) && "_w062glyw",
                                isEmpty && !title ? "_18pr1rpy" : "_18pri7uo"
                            ])
                        })
                    ]
                })
            })
        });
    return (0, $1oCLl.expValEquals)('company_hub_carousel_thumbnails-refactor', 'isEnabled', true) ? /*#__PURE__*/ (0, $l998X.jsx)($41e0790936a03f2d$var$NavigationThumbnailWrapper, {
        minWidth: minWidth ?? (0, $9Uxg8.framesDimensions)[(0, $9Uxg8.FrameSizes).NAVIGATION_THUMBNAIL].minWidth,
        maxWidth: maxWidth ?? (0, $9Uxg8.framesDimensions)[(0, $9Uxg8.FrameSizes).NAVIGATION_THUMBNAIL].maxWidth,
        height: wrapperHeight ?? (0, $9Uxg8.framesDimensions)[(0, $9Uxg8.FrameSizes).NAVIGATION_THUMBNAIL].height,
        hasRoundedCorners: hasRoundedCorners,
        isSelected: isSelected,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
            testId: "thumbnail",
            xcss: (0, $1Whri.cx)($41e0790936a03f2d$var$styles.pressable, isSelectedToEdit && $41e0790936a03f2d$var$styles.selectedToEdit, isSelectedToRemove && $41e0790936a03f2d$var$styles.selectedToRemove),
            onClick: ()=>setSelectedHeroFrameIndex(index),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "center",
                alignInline: "start",
                xcss: $41e0790936a03f2d$var$styles.container,
                children: [
                    showCustomUploadedImage ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $41e0790936a03f2d$var$styles.image
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kHNfU.CustomImageUploadRenderer), {
                            contentId: contentId,
                            imageSrc: imageSrc
                        })
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: imageSrc,
                        alt: "",
                        className: (0, $gMc0m.default)([
                            $41e0790936a03f2d$var$styles.image
                        ])
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $41e0790936a03f2d$var$styles.textWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("p", {
                            className: (0, $gMc0m.default)([
                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _3fcw1g80 _11c8fhey _y3gnv2br _ffi410nf"
                            ]),
                            children: title || intl.formatMessage((0, $65e0ee6de15b2b8b$export$defe85febe8b728c).emptyStatePlaceholderTitle)
                        })
                    })
                ]
            })
        })
    }) : oldThumbnail();
};
const $41e0790936a03f2d$var$titleBlockLinkTextColorStyles = null;
const $41e0790936a03f2d$var$titleBlockLinkTextSubtlestColorStyles = null;
const $41e0790936a03f2d$var$titleBlockHideUnauthorizedStyles = null;
const $41e0790936a03f2d$var$titleBlockStylesV2 = null;
const $41e0790936a03f2d$var$customImageUploadStyles = null;
const $41e0790936a03f2d$var$customBackgroundStyles = {
    backgroundColorOnly: "_kqswstnw _1bsb17pg _154ize3t _94n5ze3t _1ltvze3t"
};
const $41e0790936a03f2d$var$carouselV2CustomImageWidth = null;


const $82e761904cedabe5$var$IMAGE_PERCENTAGE = 0.575;
const $82e761904cedabe5$var$styles = {
    containerStyles: "_1reo15vq _18m915vq _1e0c1txw _kqswh2mm _2lx2vrvc _1bsb1osq _1bah1y6m _rjfvx6dd"
};
const $82e761904cedabe5$export$daaa732503241aed = (carouselRef)=>{
    if (!carouselRef.current) return false;
    const rect = carouselRef.current.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
};
const $82e761904cedabe5$export$d5bb600df302dfc8 = ({ extensionLocalId: extensionLocalId, parameters: parameters, contentId: contentId, isCompanyHub: isCompanyHub, isInViewMode: isInViewMode })=>{
    const [{ selectedExtensionLocalId: selectedExtensionLocalId, selectedToEditCardId: selectedToEditCardId, selectedToRemoveCardId: selectedToRemoveCardId }, { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId }] = (0, $g3LxX.useExtensionsState)();
    const { smartCardProviderComponent: smartCardProviderComponent } = (0, $fOKpq.useProductDependencies)();
    const SmartCardProvider = smartCardProviderComponent || (0, $42omo.Fragment);
    const [selectedFrameIndex, setSelectedFrameIndex] = (0, $42omo.useState)(0);
    // Separately track the index of the hero card that should be scrolled to.
    // This should be in sync with selected frame index above, but this one
    // starts at -1 to prevent scrolling on mount.
    const [scrollToHeroFrameAtIndex, setScrollToHeroFrameAtIndex] = (0, $42omo.useState)(-1);
    const { cards: frames, cornerStyle: cornerStyle, isAutoplayEnabled: isAutoplayEnabled, navigationStyle: navigationStyle } = parameters;
    const hasRoundedCorners = cornerStyle === (0, $4cOi8.CornerStyle).ROUNDED || !isCompanyHub || !cornerStyle;
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [width, setWidth] = (0, $42omo.useState)((0, $1A6sR.VERTICAL_MAX_WIDTH) + 1);
    const frameIds = frames.map((frame)=>frame.cardId);
    const handleSelectFrameAtIndex = (0, $42omo.useCallback)((requestedIndex)=>{
        setScrollToHeroFrameAtIndex(requestedIndex);
        setSelectedFrameIndex(requestedIndex);
        if (!isInViewMode && extensionLocalId === selectedExtensionLocalId) {
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(frameIds[requestedIndex]);
        }
    }, [
        setScrollToHeroFrameAtIndex,
        setSelectedFrameIndex,
        frameIds,
        isInViewMode,
        setIsInAutoFocusMode,
        setSelectedToEditCardId,
        extensionLocalId,
        selectedExtensionLocalId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (selectedFrameIndex > frames.length - 1) handleSelectFrameAtIndex(frames.length - 1);
        if (!isInViewMode && selectedToEditCardId) {
            const index = frames.findIndex((card)=>card.cardId === selectedToEditCardId);
            if (index !== -1) handleSelectFrameAtIndex(index);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        frames.length,
        selectedFrameIndex,
        handleSelectFrameAtIndex,
        selectedToEditCardId,
        isInViewMode
    ]);
    const carouselRef = (0, $42omo.useRef)(null);
    const spotlightHero = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($82e761904cedabe5$var$styles.containerStyles),
        children: [
            frames.map(({ cardId: cardId, backgroundColor: backgroundColor, layout: layout, imageSrc: imageSrc, imageAltText: imageAltText, title: title, description: description, textColor: textColor, link: link, buttonStyle: buttonStyle, buttonText: buttonText }, index)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $jPFXE.CarouselLayoutRenderer), {
                    index: index,
                    frameSetLength: frames.length,
                    selectedFrameIndex: scrollToHeroFrameAtIndex,
                    extensionLocalId: extensionLocalId,
                    testId: `carousel-spotlight-${index}--${index === selectedFrameIndex ? 'active' : 'not-active'}`,
                    backgroundColor: backgroundColor,
                    height: (0, $4cOi8.Height).MEDIUM,
                    layout: layout,
                    imageData: imageSrc,
                    imageAltText: imageAltText,
                    width: width,
                    imageWidthPercentage: $82e761904cedabe5$var$IMAGE_PERCENTAGE,
                    title: title,
                    description: description,
                    textColor: textColor,
                    link: link,
                    buttonStyle: buttonStyle,
                    buttonText: buttonText,
                    contentId: contentId,
                    hasRoundedCorners: hasRoundedCorners,
                    source: (0, $5Ac5G.carouselContentAnalyticSource)
                }, cardId);
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: setWidth,
                offscreen: true
            })
        ]
    });
    const handleMouseOrFocusChange = (event)=>{
        if (event === 'enter') setIsHovered(true);
        else setIsHovered(false);
    };
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        onMouseEnter: ()=>handleMouseOrFocusChange('enter'),
        onMouseLeave: ()=>handleMouseOrFocusChange('leave'),
        onFocusCapture: ()=>handleMouseOrFocusChange('enter'),
        onBlurCapture: ()=>handleMouseOrFocusChange('leave'),
        ref: carouselRef,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            wrap: "wrap",
            gap: "space.150",
            testId: "carousel-v2-content-container",
            children: [
                spotlightHero,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $a67f58337016b064$export$6239edc19b7276da), {
                    isInViewMode: !!isInViewMode,
                    frameIds: frames.map((frame)=>frame.cardId),
                    selectedHeroFrameIndex: selectedFrameIndex,
                    setSelectedHeroFrameIndex: handleSelectFrameAtIndex,
                    extensionLocalId: extensionLocalId,
                    isHovered: isHovered,
                    isCarouselVisible: ()=>$82e761904cedabe5$export$daaa732503241aed(carouselRef),
                    isAutoplayEnabled: isAutoplayEnabled && isInViewMode,
                    navigationStyle: navigationStyle || (0, $9Uxg8.NavigationStyle).THUMBNAILS,
                    width: width,
                    frames: frames.map((frame, index)=>{
                        const isSelectedToEdit = selectedToEditCardId === frame.cardId && extensionLocalId === selectedExtensionLocalId;
                        const isSelectedToRemove = selectedToRemoveCardId === frame.cardId && extensionLocalId === selectedExtensionLocalId;
                        return (0, $1oCLl.expValEquals)('company_hub_carousel_thumbnails-refactor', 'isEnabled', true) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $41e0790936a03f2d$export$3c072ff478476aa0), {
                            contentId: contentId,
                            wrapperHeight: 40,
                            minWidth: 200,
                            maxWidth: 200,
                            onSucceeded: ()=>{},
                            onFailed: ()=>{},
                            isEmpty: !frame.link,
                            isSelected: selectedFrameIndex === index,
                            hasRoundedCorners: hasRoundedCorners,
                            ...frame,
                            setSelectedHeroFrameIndex: handleSelectFrameAtIndex,
                            index: index,
                            isSelectedToEdit: isSelectedToEdit,
                            isSelectedToRemove: isSelectedToRemove
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $d383b1063b3ff59a$export$d3fc0aff4df25c77), {
                            itemId: frame.cardId,
                            extensionLocalId: extensionLocalId,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $41e0790936a03f2d$export$3c072ff478476aa0), {
                                contentId: contentId,
                                wrapperHeight: 40,
                                minWidth: 200,
                                maxWidth: 200,
                                onSucceeded: ()=>{},
                                onFailed: ()=>{},
                                isEmpty: !frame.link,
                                isSelected: selectedFrameIndex === index,
                                hasRoundedCorners: hasRoundedCorners,
                                ...frame,
                                setSelectedHeroFrameIndex: handleSelectFrameAtIndex,
                                index: index
                            })
                        }, frame.cardId);
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)(SmartCardProvider, {
        children: content
    });
};
module.exports["CarouselContentV2"] = $82e761904cedabe5$export$d5bb600df302dfc8;

});


//# sourceMappingURL=carousel-extension.93828454.js.map
